import { Field } from 'formik'
import React from 'react'

import { Fieldset, Input } from '@fourthwall/components'

export const RangeForm = () => {
  return (
    <>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field name="label" component={Input} label="Label" placeholder="Setting label" />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field
            name="default"
            component={Input}
            label="Default Value (optional)"
            placeholder="Default value"
          />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field name="min" component={Input} label="Minimum Value" type="number" />
        </Fieldset.Item>
        <Fieldset.Item>
          <Field name="max" component={Input} label="Maximum Value" type="number" />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field name="step" component={Input} label="Step" type="number" />
        </Fieldset.Item>
        <Fieldset.Item>
          <Field name="unit" component={Input} label="Unit (optional)" placeholder="px, %, etc." />
        </Fieldset.Item>
      </Fieldset.Row>
    </>
  )
}
